import React, { createContext, useContext, useState, useCallback } from 'react';

const SportSelectionContext = createContext(null);

export const SportSelectionProvider = ({ children }) => {
  const [activeSport, setActiveSportState] = useState('cricket');

  const setActiveSport = useCallback((sport) => {
    setActiveSportState(sport);
  }, []);

  return (
    <SportSelectionContext.Provider value={{ activeSport, setActiveSport }}>
      {children}
    </SportSelectionContext.Provider>
  );
};

export const useSportSelection = () => {
  const context = useContext(SportSelectionContext);
  if (!context) {
    throw new Error('useSportSelection must be used within a SportSelectionProvider');
  }
  return context;
};
